import TemplateView from "../../TemplateView";

export default class MoreElementsBlockedListItem extends TemplateView {
    constructor($containerEl, title) {
        super($containerEl);
        this.title = title;
    }

    templateHtml() {
        return "<div class='blockedListItem moreElements'>" +
               "  <div class='title'><i><%-title%></i></div>" +
               "</div>";
    }
}


// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/MoreElementsBlockedListItem.js